import { useQuery } from 'react-query';
import { ticketsService } from '../Utils/ticketsService';
import usePersonalInfo from 'src/Views/PersonalInfo/usePersonalInfo';
export var useTicket = function (id) {
    var userProfile = usePersonalInfo().data;
    var _a = useQuery(['ticket', id], function () { return ticketsService.getTicket(id); }, {
        enabled: !!id,
        onError: function (err) {
            console.error('Error fetching ticket:', err);
        },
    }), data = _a.data, isLoading = _a.isLoading, error = _a.error, refetch = _a.refetch;
    return {
        ticket: (data === null || data === void 0 ? void 0 : data.ticket) || null,
        loading: isLoading,
        error: error ? 'Error al cargar el ticket' : null,
        refetch: refetch,
    };
};
